import index from '../../contentBlocks/components/banner.js';
export default index;